// Canonical human-facing identity label, mirroring pgp-auth's display_identity.
//
// Alchemy SSO users have no mailbox; the backend stores a non-routable
// placeholder (historically `<key>@alchemy.local`). Always present SSO users
// as `<masterPersKey>@alchemy-sso` so the CRM origin is obvious and the
// internal placeholder domain never surfaces. Local accounts show their email.

export const ALCHEMY_IDENTITY_SUFFIX = '@alchemy-sso';

const PLACEHOLDER_DOMAINS = /@(alchemy\.local|alchemy-sso\.example\.com)$/i;

export function alchemyIdentityLabel(masterPersKey) {
  return `${String(masterPersKey).trim().toLowerCase()}${ALCHEMY_IDENTITY_SUFFIX}`;
}

export function formatIdentity(user) {
  if (!user) return '';
  if (user.identity) return user.identity;
  if (user.masterPersKey) return alchemyIdentityLabel(user.masterPersKey);
  const email = user.email || '';
  // Normalise a legacy placeholder email even when masterPersKey isn't present
  // on this object (e.g. the slim header user).
  if (PLACEHOLDER_DOMAINS.test(email)) {
    return email.replace(PLACEHOLDER_DOMAINS, ALCHEMY_IDENTITY_SUFFIX);
  }
  return email || user.username || user.name || '';
}
